import { render } from "./FormRegisterComp.vue?vue&type=template&id=4818442a&scoped=true"
import script from "./FormRegisterComp.vue?vue&type=script&lang=js"
export * from "./FormRegisterComp.vue?vue&type=script&lang=js"

import "./FormRegisterComp.vue?vue&type=style&index=0&id=4818442a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4818442a"]])

export default __exports__